export enum Country {
  AUS = 'au'
}

export enum CountryFullName {
  AUS = 'Australia'
}

export const CountryNameMap = {
  [Country.AUS]: CountryFullName.AUS
} as const

export enum CountryPhoneCode {
  AUS = '61'
}

export const CountryPhoneCodeMap = {
  [Country.AUS]: CountryPhoneCode.AUS
} as const

export enum CountryId {
  AUS = 1
}

export const CountryIdMap = {
  [Country.AUS]: CountryId.AUS
} as const
